export default __webpack_public_path__ + "static/media/main_circle.7746aa99.svg";